import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'

const MyProfileIaEvaluationStyled = styled.div`
  .containerHeader {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    max-width: 100%;
    /* Sin tarjeta blanca: el mismo padding de página (30px 60px) que el resto de páginas de admin */
    padding: 30px 60px;
    gap: 50px;
  }

  .sectionSecond {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 15px;

    & h2 {
      font-size: 20px; /* título de página de Velora, igual que candidatos y favoritos */
      font-weight: 600;
      line-height: 1.2;
      color: ${tokens.color.text.primary};
      margin-bottom: 0;
    }
    & h5 {
      font-size: 14px;
      font-weight: 400;
      color: ${tokens.color.text.tertiary};
      line-height: inherit;
    }

    & p {
      font-weight: 400;
      color: #7a808d;
    }
  }

  /* Criterios centrados; Acciones (la última) a la izquierda, como sus iconos */
  .MuiTableHead-root th:nth-child(n+3):not(:last-child) {
    text-align: center !important;
    padding-right: 12px!important;
  }

  .MuiTableHead-root th:last-child {
    text-align: left !important;
  }

  .MuiTableHead-root th:not(:nth-child(n+3)) {
    text-align: left !important;
  }

  /* Buscador a la izquierda y toggle Activos / Inactivos a la derecha, como en Usuarios */
  .headerTable {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;
    margin-bottom: 24px;
  }

  .relevance_level_legend {
    display: flex;
    gap: 20px;
    margin-bottom: 16px;
    font-size: 14px;
    color: ${tokens.color.text.secondary};

    div {
      display: flex;
      align-items: center;
      gap: 8px;
    }
  }

  .MuiTableCell-root {
    font-family: 'Poppins';
  }
`

export default MyProfileIaEvaluationStyled
